import * as React from "react";
import { Table, Typography } from "antd";
import { INonPaidActivity } from "../../../../model/report/applicantdata/NonPaidActivity";

const NonPaidActivityGrid = ({
  translate,
  data
}: {
  translate?: any;
  data?: INonPaidActivity[];
}) => {
  const columns = [
    {
      title: translate("report8.document_template.non_paid_activities.name"),
      dataIndex: "name",
      key: "nonPaidActivitiesName"
    },
    {
      title: translate(
        "report8.document_template.non_paid_activities.activity_type"
      ),
      dataIndex: "activityType",
      key: "activityType"
    },
    {
      title: translate(
        "report8.document_template.non_paid_activities.activity_source"
      ),
      dataIndex: "legalOrNatualEntity",
      key: "legalOrNatualEntity"
    },
    {
      title: translate(
        "report8.document_template.non_paid_activities.date_from"
      ),
      dataIndex: "dateFrom",
      key: "nonPaidActivitiesDateFrom"
    },
    {
      title: translate("report8.document_template.non_paid_activities.date_to"),
      dataIndex: "dateTo",
      key: "nonPaidActivitiesDateTo"
    },
    {
      title: translate(
        "report8.document_template.non_paid_activities.description"
      ),
      dataIndex: "description",
      key: "nonPaidActivitiesDescription"
    }
  ];
  return (
    <div>
      <Typography.Title style={{ fontSize: 12, marginBottom: 20 }}>
        {translate("report8.document_template.non_paid_activities.title")}
      </Typography.Title>
      <Table
        bordered
        dataSource={data}
        columns={columns}
        pagination={false}
        size={"small"}
        locale={{ emptyText: translate("reports.table.no_data") }}
        style={{ marginBottom: 15 }}
      />
    </div>
  );
};

export default NonPaidActivityGrid;
